import store from '@/store'
import router from '@/router'
import localStore from '@/utils/localStore'
import {
    loginByPassword
} from '@/api/common/login'

/*
 * 로그인을 위한 함수 정의
 * api 사용를 위해 아래 2개 페이지 수정 필요
 * src/api/common/login.js [let apitest = true]
 * scr/store/modules/user.js [LoginByPassword => let isTest = true]
 */

// 자동 로그인 체크
export function fn_AutoLogin() {
    return Boolean(localStore.get('isAutoLogin'))
}

// 로그인
// [Object] userData (userId, userPw, comCode, isAutoLogin)
export function fn_Login(userData) {
    // console.log('userData', userData)

    return new Promise(function (resolve, reject) {
        let RESULT = {
            result: false,
            msg: '사용자 정보를 입력해주세요.'
        }
        // 로딩 시작 함수 만들기
        //if (domainData.value !== '') {
        if (!userData.userId || userData.userId === '') {
            RESULT.result = false
            RESULT.msg = 'Input your ID.'
            resolve(RESULT)
            return
        }
        if (!userData.userPw || userData.userPw === '') {
            RESULT.result = false
            RESULT.msg = 'Input your Password.'
            resolve(RESULT)
            return
        }

        let userInfo = {
            userId: userData.userId,
            userPw: userData.userPw,
            sysId: userData.system
            // comCode: userData.comCode,
            // isAutoLogin: userData.isAutoLogin
        }

        let map = ''

        loginByPassword(userInfo).then(login_res => {
            // 로그인 성공 
            console.log(login_res)
            if (login_res.success) {
                if (login_res.map.msg) {
                    if (login_res.map.msg === 'id' || login_res.map.msg === 'pw') {
                        RESULT.result = false
                        RESULT.msg = 'loginFail'
                        resolve(RESULT)
                        return
                    }
                }
                // console.log('loginByPassword : ', login_res)
                store
                    .dispatch('user/LoginByPassword', {
                        userInfo,
                        login_res
                    })
                    .then(response => {
                        store
                            .dispatch('user/SetUserInfo', {
                                userId: userData.userId,
                                userPw: userData.userPw,
                                sysId: userData.system
                                // comCode: userData.comCode
                            })
                            .then(response => {
                                // console.log('response : ', response)
                                // store
                                //     .dispatch('GetMenus', {
                                //         userId: userData.userId,
                                //         comCode: userData.comCode
                                //     })
                                //     .then(response => {

                                RESULT.result = login_res.success
                                RESULT.msg = login_res.msg
                                resolve(RESULT)
                                return
                                // })
                            })
                    })
                    .catch(reject => {
                        RESULT.result = false
                        RESULT.msg = '사용자 정보 조회에 실패하였습니다. 관리자에 문의해주세요'
                        resolve(RESULT)
                        return
                    })
            } else {
                RESULT.result = login_res.success
                RESULT.msg = login_res.msg
                resolve(RESULT)
                return
            }
        }).catch(error => {
            RESULT.result = false
            RESULT.msg = error.message
            resolve(RESULT)
            return
        })
        /* } else {
            RESULT.result = false
            RESULT.msg = '도메인을 확인해주세요'
            resolve(RESULT)
            return
        }  */
    })
}

// 성공 페이지 이동
export function fn_LoginSuccess(system) {
    let startPage = system// localStore.get('start-page')
    // console.log('startPage',startPage)
    if (startPage) {
        if (startPage === 'HYCOT') {
            // store.dispatch('app/setIsScreenFull', true)
            router.push('/home0000')
        } else {
            // router.push('/home0000')
        }
    } else {
        router.push('/home0000')
    }
}

// 로그아웃
export function fn_Logout() {
    router.push('/logout')
}